<template>
  <div :class="'ratioCard-cmp ' +
    (appColor == 'success' ? 'green' : appColor == 'error' ? 'red' : '')
    ">
    <div class="cbody">
      <h3 class="mainText"><strong>
        {{ mainText
        }}</strong><span :class="chip ? 'chip' : ''">{{
          chip ? (chip.length ? chip : "") : ""
          }}</span>
      </h3>
      <p class="subText">{{ subText }}</p>
    </div>
    <v-icon v-if="tooltip" class="icon tooltip" icon>fa-circle-info</v-icon>
    <div v-if="tooltip" class="tooltip hidden">
      {{ tooltip.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RatioCard",
  mounted() { },
  props: {
    chip: {
      type: String,
    },
    mainText: {
      type: String,
    },
    subText: {
      type: String,
    },
    appColor: {
      type: String,
    },
    tooltip: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--dark {
  .ratioCard-cmp {
    background-color: #232830 !important;
  }
}

.ratioCard-cmp {
  background-color: transparent !important;
  border-radius: 8px;
  padding: 11px 22px;
  border-left: 4px solid var(--v-mainBlack-base) !important;
  color: var(--v-mainBlack-base);
  position: relative;
  border: 0.5px solid var(--v-mainBlack-base);

  .chip {
    background: var(--v-mainGreen-base);
    padding: 2px 8px;
    border-radius: 5px;
    color: var(--v-darkGreen-base) !important;
    margin-left: 7px;
    font-size: 12px !important;
    @media (max-width: 768px) {
      margin-left: 0px;
      margin-bottom: 4px;
    }
  }

  &.red {
    border-left: 4px solid var(--v-darkRed-base) !important;
    color: var(--v-darkRed-base) !important;
    border-color: var(--v-darkRed-base) !important;
  }

  &.green {
    border-left: 4px solid var(--v-darkGreen-base) !important;
    color: var(--v-darkGreen-base) !important;
    border-color: var(--v-darkGreen-base) !important;
  }

  .cbody {
    color: inherit;
    display: flex;
    flex-direction: column;

    .mainText {
      display: flex;
      margin: 0;
      margin-right: 5px;
      font-weight: 600;
      color: inherit !important;

      @media (max-width: 768px) {
        flex-direction: column-reverse;
      }
    }

    .subText {
      font-size: 16px;
      margin: 0;
      margin-top: 5px;
      color: inherit !important;
    }
  }

  .icon.tooltip {
    color: inherit;
    position: absolute;
    width: 14px;
    height: 14px;
    bottom: 0;
    right: 0;
  }
}
</style>
